// src/components/Dashboard/Sidebar.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
    Drawer,
    Toolbar,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListSubheader,
} from "@mui/material";

const drawerWidth = 240;

const Sidebar = ({
                     userRole,
                     onDashboard,
                     onUserManagement,
                     onBrokerManagement,
                     onInstrument,
                     onTradesOrders,
                     onProfitPlans,
                 }) => {
    return (
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
            }}
        >
            <Toolbar>
                <Typography variant="h6" noWrap component="div">
                    Trading Bot
                </Typography>
            </Toolbar>
            <Divider />
            <List>
                <ListItem disablePadding>
                    <ListItemButton onClick={onDashboard}>
                        <ListItemText primary="Dashboard" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={onInstrument}>
                        <ListItemText primary="Instruments" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={onTradesOrders}>
                        <ListItemText primary="Trades/Orders" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                    <ListItemButton onClick={onProfitPlans}>
                        <ListItemText primary="Profit Plans" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding><ListItemButton component={Link} to="/strike-live"><ListItemText primary="Live Top 3 Strikes" /></ListItemButton></ListItem>
                <ListItem disablePadding><ListItemButton component={Link} to="/strike-lab"><ListItemText primary="Dynamic Strike Lab" /></ListItemButton></ListItem>

                {userRole === "admin" && (
                    <>
                        <ListSubheader>Admin Panel</ListSubheader>
                        <ListItem disablePadding><ListItemButton component={Link} to="/system-health"><ListItemText primary="System Health" /></ListItemButton></ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={onUserManagement}>
                                <ListItemText primary="User Management" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={onBrokerManagement}>
                                <ListItemText primary="Broker Management" />
                            </ListItemButton>
                        </ListItem>
                    </>
                )}
            </List>
        </Drawer>
    );
};

export default Sidebar;
